import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ResourceState = {
  checklists: any[];
  requestForms: any[];
};

const initialState: ResourceState = {
  checklists: [],
  requestForms: [],
};

const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    setChecklists(state, action: PayloadAction<any[]>) {
      state.checklists = Array.isArray(action.payload) ? action.payload : [];
    },
    setRequestForms(state, action: PayloadAction<any[]>) {
      state.requestForms = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export const { setChecklists, setRequestForms } = resourcesSlice.actions;
export default resourcesSlice.reducer;
